import script from "./Introduction.vue?vue&type=script&setup=true&lang=js"
export * from "./Introduction.vue?vue&type=script&setup=true&lang=js"

import "./Introduction.vue?vue&type=style&index=0&id=27698738&scoped=true&lang=css"

import exportComponent from "/Users/hou/Desktop/zijie/sdxlxh_user/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27698738"]])

export default __exports__